import { AxiosRequestConfig } from "axios";
import axiosInstance from "./axiosInstance";

export const apiClient = {
  get: <T>(url: string, params?: object, p0?: { signal: AbortSignal }) =>
    axiosInstance.get<T>(url, { params }),

  post: <T>(url: string, data?: object, config?: AxiosRequestConfig) =>
    axiosInstance.post<T>(url, data, config),

  put: <T>(url: string, data?: object, config?: AxiosRequestConfig) =>
    axiosInstance.put<T>(url, data, config),

  delete: <T>(url: string, config?: AxiosRequestConfig) =>
    axiosInstance.delete<T>(url, config),
};
